import { lookupCard } from "../../content/index.js";
import { applyEffect } from "../cards/applyEffect.js";
import { accept, reject } from "../reducer/reject.js";
import type { GameState, RunState } from "../types/index.js";
import { continuePendingRepeat, withReshuffleLog } from "./completion.js";

type FocusChoice = Extract<NonNullable<RunState["pendingChoice"]>, { kind: "focus" }>;

export function toggleFocusChoice(
  state: GameState,
  pending: FocusChoice,
  selected: "hand" | "aside",
): GameState {
  return accept({ ...state, run: { ...state.run!, pendingChoice: { ...pending, selected } } });
}

export function submitFocusChoice(state: GameState, pending: FocusChoice): GameState {
  const run = state.run!;
  if (!pending.pendingCard || !pending.selected || !run.activeCase) return reject(state, "置き場所を選んでください");
  const placed = pending.selected === "hand"
    ? { ...run, hand: [...run.hand, pending.pendingCard], pendingChoice: null }
    : { ...run, aside: [...run.aside, pending.pendingCard], pendingChoice: null };
  const definition = lookupCard("focus");
  const result = definition?.effect
    ? applyEffect({ run: placed, activeCase: run.activeCase, sourceInstanceId: pending.sourceInstanceId }, definition.effect)
    : { run: placed, activeCase: run.activeCase, reshuffled: false };
  return accept({ ...state, run: withReshuffleLog(run, continuePendingRepeat({ ...result.run, activeCase: result.activeCase }), result.reshuffled) });
}
